<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div *ngIf="isEntityForeign == '0'">


    <mat-dialog-content *ngIf="invoiceDetails.length > 0">
        <div class="main_div"  #captureContainer id="print-section">
            <div class="invoice_details add_padding" style="position: relative;">
                <!-- button start -->
                
                <!-- <div class="example-button-row" style="position: absolute; right: 0px">
                    <div class="example-flex-container">
                        <div class="example-button-container">
                            <button mat-mini-fab color="primary" aria-label="Example icon button with a menu icon" (click)="captureScreen()">
                                <mat-icon>download_2</mat-icon>
                            </button>
                        </div>
                </div>
            </div>  -->

            <div class="prin_download">
                <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu2="matMenu">
                    <button mat-menu-item (click)="captureScreen()"> 
                        <mat-icon class="material-icons-outlined">download_2</mat-icon>
                        <span>Download invoice</span>
                    </button>
                    <button mat-menu-item printSectionId="print-section" ngxPrint [useExistingCss]="true" [printTitle]="invoiceDetails[0].inv_no"> 
                        <mat-icon class="material-icons-outlined">print</mat-icon>
                        <span>Print invoice</span>
                    </button>
                    <button mat-menu-item (click)="shareInWhatsapp()" class="whatsp_iocn"> 
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 682 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path fill-rule="evenodd" d="M544.387 93.008C484.512 33.063 404.883.035 320.05 0 145.246 0 2.98 142.262 2.91 317.113c-.024 55.895 14.577 110.457 42.331 158.551L.25 640l168.121-44.102c46.324 25.27 98.477 38.586 151.55 38.602h.134c174.785 0 317.066-142.273 317.132-317.133.036-84.742-32.921-164.418-92.8-224.36zM320.05 580.94h-.11c-47.296-.02-93.683-12.73-134.16-36.742l-9.62-5.715-99.766 26.172 26.628-97.27-6.27-9.972c-26.386-41.969-40.32-90.476-40.296-140.281.055-145.332 118.305-263.57 263.7-263.57 70.406.023 136.59 27.476 186.355 77.3s77.156 116.051 77.133 186.485C583.582 462.69 465.34 580.94 320.05 580.94zm144.586-197.418c-7.922-3.968-46.883-23.132-54.149-25.78-7.258-2.645-12.547-3.962-17.824 3.968-5.285 7.93-20.469 25.781-25.094 31.066-4.625 5.29-9.242 5.953-17.168 1.985-7.925-3.965-33.457-12.336-63.726-39.332-23.555-21.012-39.457-46.961-44.082-54.89-4.617-7.938-.04-11.813 3.476-16.173 8.578-10.652 17.168-21.82 19.809-27.105 2.644-5.29 1.32-9.918-.664-13.883-1.977-3.965-17.824-42.969-24.426-58.84-6.437-15.445-12.965-13.36-17.832-13.601-4.617-.231-9.902-.278-15.187-.278-5.282 0-13.868 1.98-21.133 9.918-7.262 7.934-27.73 27.102-27.73 66.106s28.394 76.683 32.355 81.972c3.96 5.29 55.879 85.328 135.367 119.649 18.906 8.172 33.664 13.043 45.176 16.695 18.984 6.031 36.254 5.18 49.91 3.14 15.226-2.277 46.879-19.171 53.488-37.68 6.602-18.51 6.602-34.374 4.617-37.683-1.976-3.304-7.261-5.285-15.183-9.254zm0 0" fill="#2d2d2d" opacity="1" data-original="#000000" class=""></path></g></svg>
                        <span>Share in WhatsApp</span>
                    </button>
                    <button mat-menu-item (click)="shareInEmail()"> 
                        <mat-icon class="material-icons-outlined">mail</mat-icon>
                        <span>Share in Email</span>
                    </button>
                    <button mat-menu-item (click)="deleteInvoice()" *ngIf="isOwner && !invoiceDetails[0].pay_ref_id && invoiceDetails[0].payment_mode != 'Wallet'">
                        <mat-icon class="material-icons-outlined">delete</mat-icon>
                        <span>Delete invoice</span>
                    </button>
                    <!-- <button mat-menu-item (click)="mergeInvoices()" *ngIf="invoiceDetails[0].appointmentArr.length == 1 && invoiceDetails[0].paymentStatus != 1">
                        <mat-icon class="material-icons-outlined">add</mat-icon>
                        <span>Add Appointments</span>
                    </button> -->
                  
                </mat-menu>
            </div>

            <h4 class="make_grey">Tax Invoice</h4>

            <p class="make_bold add_margin_bottom">{{invoiceDetails[0].inv_no}}</p>
    
            <p class="make_bold add_margin_bottom namebusinessx">{{invoiceDetails[0].entity_name}}</p>
    
            <p class="make_bold add_margin_bottom">{{invoiceDetails[0].entity_address}}</p>
            <div class="created_by add_margin_bottom" add_margin_bottom>
                <span class="make_grey">Created by:</span> <p class="make_bold add_margin_left ">{{invoiceDetails[0].creator_name}}</p>
            </div>
            <div class="created_by" *ngIf="invoiceDetails[0].gst_no && invoiceDetails[0].gst_no != 'null'">
                <span class="make_grey">GST:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].gst_no && invoiceDetails[0].gst_no != 'null' ? invoiceDetails[0].gst_no : 'N/A'}}</p>
            </div>
            <div class="created_by" *ngIf="invoiceDetails[0].pan_no && invoiceDetails[0].pan_no != 'null'">
                <span class="make_grey">PAN:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].pan_no && invoiceDetails[0].pan_no != 'null' ? invoiceDetails[0].pan_no : 'N/A'}}</p>
            </div>
            <div class="created_by" *ngIf="invoiceDetails[0].tan_no && invoiceDetails[0].tan_no != 'null'">
                <span class="make_grey">TAN:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].tan_no && invoiceDetails[0].tan_no != 'null' ? invoiceDetails[0].tan_no : 'N/A'}}</p>
            </div>
            
        </div>
    
        <div class="cust_info add_padding">
            <div class="created_by add_margin_bottom">
                <span class="make_grey">Bill to:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].cust_name && invoiceDetails[0].cust_name != 'null' ? invoiceDetails[0].cust_name : 'N/A'}}</p>
            </div>
            <div class="created_by add_margin_bottom" *ngIf="invoiceDetails[0].appointmentArr.length > 1">
                <span class="make_grey">For {{invoiceDetails[0].appointmentArr.length}} bookings</span> 
            </div>
            <div class="created_by add_margin_bottom">
                <span class="make_grey">Phone:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].customer_country_code && invoiceDetails[0].customer_country_code != 'null'  ? invoiceDetails[0].customer_country_code : '+91'}} {{invoiceDetails[0].cust_phone && invoiceDetails[0].cust_phone != 'null'  ? invoiceDetails[0].cust_phone : 'N/A'}}</p>
            </div>
            <div class="created_by add_margin_bottom">
                <span class="make_grey">Date:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].invoice_date | date}}</p>
            </div>
        </div>
    
        <div class="item_list add_padding">
            <div class="item_list_data add_margin_bottom" *ngFor="let item of invoiceDetails[0].invoiceDetails">
                <span>{{item.serv_name}} x {{item.serv_quantity}}</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{item.serv_cost.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngFor="let item of invoiceDetails[0].products">
                <span>{{item.product_name}} x {{item.product_quantity}}</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{item.product_cost.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngFor="let item of invoiceDetails[0].custom_items">
                <span>{{item.item_name}} x {{item.item_qty}}</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{item.item_price.toFixed(2)}}</p>
            </div>
        </div>
    
        <div class="item_list add_padding" >
            <div class="item_list_data add_margin_bottom">
                <span>Total</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].item_price.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].invoice_bill_type == 2 && invoiceDetails[0].total_tax && invoiceDetails[0].total_tax != '0.00' && invoiceDetails[0].total_tax != '0'">
                <span>Tax</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{(+invoiceDetails[0].total_tax).toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].discount != 0">
                <span>Discount</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].discount.toFixed(2)}}</p>
            </div>
             <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].coupon_discount && invoiceDetails[0].coupon_discount != 0">
                <span>Coupon discount</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].coupon_discount.toFixed(2)}}</p>
            </div>
            
           
            
        </div>
    
        <div class="item_list add_padding">
            <!-- <div class="item_list_data add_margin_bottom">
                <span>Total tax collected</span > <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].total_tax.toFixed(2)}}</p>
            </div> -->
            <div class="item_list_data add_margin_bottom">
                <span>Net payable</span > <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].total_price.toFixed(2)}}</p>
            </div>
        </div>
        <div class="item_list add_padding">
            <div class="item_list_data add_margin_bottom">
                <span>Payment Amount</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].customer_payment ? invoiceDetails[0].customer_payment.toFixed(2) : '0.00'}}</p>
            </div>
            <div class="item_list_data add_margin_bottom">
                <span>Payment Due</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].payment_due ? invoiceDetails[0].payment_due.toFixed(2) : '0.00'}}</p>
            </div> 
        </div>
        <div class="item_list add_padding">
           
            <div class="item_list_data add_margin_bottom">
                <span>Payment Mode</span> <p class="make_bold">{{invoiceDetails[0].payment_mode ? invoiceDetails[0].payment_mode : 'N/A'}}</p>
            </div>
            <div class="item_list_data add_margin_bottom">
                <span>Reference Id</span> <p class="make_bold">{{invoiceDetails[0].pay_ref_id ? invoiceDetails[0].pay_ref_id : 'N/A'}}</p>
            </div>
        </div>
        <div class="item_list add_padding" *ngIf="invoiceDetails[0].cgst_cal_rate || invoiceDetails[0].sgst_cal_rate || invoiceDetails[0].igst_cal_rate || invoiceDetails[0].utgst_cal_rate || invoiceDetails[0].service_tax_cal_rate || invoiceDetails[0].other_tax_cal_rate">
               
            <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].cgst_value && invoiceDetails[0].cgst_value != 0">
                <span>Total CGST </span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].cgst_value.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].sgst_value && invoiceDetails[0].sgst_value != 0">
                <span>Total SGST </span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].sgst_value.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].igst_value && invoiceDetails[0].igst_value != 0">
                <span>Total IGST  </span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].igst_value.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].utgst_value && invoiceDetails[0].utgst_value != 0">
                <span>Total UTGST </span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].utgst_value.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].service_tax_value && invoiceDetails[0].service_tax_value != 0">
                <span>Total Service Tax </span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].service_tax_value.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].other_tax && invoiceDetails[0].other_tax != 0">
                <span>Total Other Tax </span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].other_tax.toFixed(2)}}</p>
            </div>
            
        </div>
        <div class="item_list add_padding" style="border-bottom: none;" *ngIf="invoiceDetails[0].total_tax && invoiceDetails[0].total_tax != '0.00' && invoiceDetails[0].total_tax != '0'">
           
            <div class="item_list_data add_margin_bottom" >
                <span>Total Tax Collected </span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{(+invoiceDetails[0].total_tax).toFixed(2)}}</p>
            </div>
            
            
        </div>
        <!-- <div class="cust_info" style="padding: 16px 10px;">
            <div class="created_by">
                <p class="make_grey" style="font-size: 12px;">Invoice powered by <span >Lookzup</span></p>
            </div>
            <div class="created_by">
               <p class="make_grey" style="font-size: 12px;">Visit <span >lookzup.com</span> for more info</p>
            </div>
        </div> -->
    </div>
    </mat-dialog-content>

    <mat-dialog-content *ngIf="invoiceDetails.length == 0" style="height: 615px;">
        <div style="    text-align: center;
        padding-top: 300px;">
            <h2>Loading Invoice...</h2>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" *ngIf="invoiceDetails.length > 0">


        <!-- <button  mat-flat-button   color="accent" (click)="resetInvoice()" *ngIf="invoiceDetails[0].appointmentArr.length > 1 && invoiceDetails[0].paymentStatus != 1"
        >Reset</button>
        <button  mat-flat-button   color="accent" (click)="mergeInvoices()" *ngIf="invoiceDetails[0].appointmentArr.length == 1 && invoiceDetails[0].paymentStatus != 1"
        >Add Appointments</button>-->
        <button style="color: #fff;" mat-flat-button   color="accent" (click)="openRecordPayment()" *ngIf="invoiceDetails[0].payment_due != 0"
        >Record payment</button> 
        <button style="color: #fff;" *ngIf="invoiceDetails[0].isOnlinePaymentEnabled == 1 && invoiceDetails[0].payment_due != 0"
        (click)="sendPaymentLink()" mat-flat-button color="accent">Send payment link  </button>
        <button style="color: #fff;" *ngIf="invoiceDetails[0].isOnlinePaymentEnabled != 1 || invoiceDetails[0].payment_due == 0"
        (click)="shareInWhatsapp()" mat-flat-button color="accent">Share in WhatsApp</button>
      </mat-dialog-actions>

    </div>
  <div *ngIf="isEntityForeign == '1'">


    <mat-dialog-content *ngIf="invoiceDetails.length > 0">
        <div class="main_div"  #captureContainer id="print-section">
            <div class="invoice_details add_padding" style="position: relative;">
                <!-- button start -->
                <div class="example-button-row" style="position: absolute; right: 0px">
                    <!-- <div class="example-flex-container">
                        <div class="example-button-container">
                            <button mat-flat-button color="primary" aria-label="Example icon button with a menu icon" (click)="captureScreen()">
                                <mat-icon>download_2</mat-icon> Download
                              </button>
                          </div>
                    </div> -->
                    <div class="prin_download">
                        <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu2="matMenu">
                            <button mat-menu-item (click)="captureScreen2()"> 
                                <mat-icon class="material-icons-outlined">download_2</mat-icon>
                                <span>Download invoice</span>
                            </button>
                            <button mat-menu-item printSectionId="print-section" ngxPrint [useExistingCss]="true" [printTitle]="invoiceDetails[0].inv_no"> 
                                <mat-icon class="material-icons-outlined" >print</mat-icon>
                                <span>Print invoice</span>
                            </button>
                            <button mat-menu-item (click)="shareInWhatsapp()" class="whatsp_iocn"> 
                              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 682 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path fill-rule="evenodd" d="M544.387 93.008C484.512 33.063 404.883.035 320.05 0 145.246 0 2.98 142.262 2.91 317.113c-.024 55.895 14.577 110.457 42.331 158.551L.25 640l168.121-44.102c46.324 25.27 98.477 38.586 151.55 38.602h.134c174.785 0 317.066-142.273 317.132-317.133.036-84.742-32.921-164.418-92.8-224.36zM320.05 580.94h-.11c-47.296-.02-93.683-12.73-134.16-36.742l-9.62-5.715-99.766 26.172 26.628-97.27-6.27-9.972c-26.386-41.969-40.32-90.476-40.296-140.281.055-145.332 118.305-263.57 263.7-263.57 70.406.023 136.59 27.476 186.355 77.3s77.156 116.051 77.133 186.485C583.582 462.69 465.34 580.94 320.05 580.94zm144.586-197.418c-7.922-3.968-46.883-23.132-54.149-25.78-7.258-2.645-12.547-3.962-17.824 3.968-5.285 7.93-20.469 25.781-25.094 31.066-4.625 5.29-9.242 5.953-17.168 1.985-7.925-3.965-33.457-12.336-63.726-39.332-23.555-21.012-39.457-46.961-44.082-54.89-4.617-7.938-.04-11.813 3.476-16.173 8.578-10.652 17.168-21.82 19.809-27.105 2.644-5.29 1.32-9.918-.664-13.883-1.977-3.965-17.824-42.969-24.426-58.84-6.437-15.445-12.965-13.36-17.832-13.601-4.617-.231-9.902-.278-15.187-.278-5.282 0-13.868 1.98-21.133 9.918-7.262 7.934-27.73 27.102-27.73 66.106s28.394 76.683 32.355 81.972c3.96 5.29 55.879 85.328 135.367 119.649 18.906 8.172 33.664 13.043 45.176 16.695 18.984 6.031 36.254 5.18 49.91 3.14 15.226-2.277 46.879-19.171 53.488-37.68 6.602-18.51 6.602-34.374 4.617-37.683-1.976-3.304-7.261-5.285-15.183-9.254zm0 0" fill="#2d2d2d" opacity="1" data-original="#000000" class=""></path></g></svg>
                                <span>Share in WhatsApp</span>
                            </button>
                            <button mat-menu-item (click)="shareInEmail()"> 
                                <mat-icon class="material-icons-outlined">mail</mat-icon>
                                <span>Share in Email</span>
                            </button>
                            <!-- <button mat-menu-item (click)="mergeInvoices()" *ngIf="invoiceDetails[0].appointmentArr.length == 1 && invoiceDetails[0].payment_status != 1">
                                <mat-icon class="material-icons-outlined">add</mat-icon>
                                <span>Add Appointments</span>
                            </button> -->
                            <button mat-menu-item (click)="deleteInvoice()" *ngIf="isOwner && !invoiceDetails[0].pay_ref_id && invoiceDetails[0].payment_mode != 'Wallet'">
                                <mat-icon class="material-icons-outlined">delete</mat-icon>
                                <span>Delete invoice</span>
                            </button>
                          
                        </mat-menu>
                    </div>
                </div>   
                <!-- button end -->
                <h4 class="make_grey">Tax Invoice</h4>
    
                <p class="make_bold add_margin_bottom">{{invoiceDetails[0].inv_no}}</p>
        
                <p class="make_bold add_margin_bottom namebusinessx">{{invoiceDetails[0].entity_name}}</p>
        
                <p class="make_bold add_margin_bottom">{{invoiceDetails[0].entity_address}}</p>
                <div class="created_by add_margin_bottom" add_margin_bottom>
                    <span class="make_grey">Created by:</span> <p class="make_bold add_margin_left ">{{invoiceDetails[0].creator_name ? invoiceDetails[0].creator_name : 'N/A'}}</p>
                </div>
                <div *ngIf="invoiceDetails[0].tax_type_details">

                <div class="created_by" *ngFor="let item of invoiceDetails[0].tax_type_details">
                    <span class="make_grey">{{item.taxation_type}}:</span> <p class="make_bold add_margin_left">{{item.identification_no}}</p>
                </div>
            </div>
            </div>
        
            <div class="cust_info add_padding">
                <div class="created_by add_margin_bottom">
                    <span class="make_grey">Bill to:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].cust_name && invoiceDetails[0].cust_name != 'null' ? invoiceDetails[0].cust_name : 'N/A'}}</p>
                </div>
                <div class="created_by add_margin_bottom" *ngIf="invoiceDetails[0].appointmentArr.length > 1">
                    <span class="make_grey">For {{invoiceDetails[0].appointmentArr.length}} bookings</span> 
                </div>
                <div class="created_by add_margin_bottom">
                    <span class="make_grey">Phone:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].cust_country_code && invoiceDetails[0].cust_country_code != 'null'  ? invoiceDetails[0].cust_country_code : '+91'}} {{invoiceDetails[0].cust_phone && invoiceDetails[0].cust_phone != 'null'  ? invoiceDetails[0].cust_phone : 'N/A'}}</p>
                </div>
                <div class="created_by add_margin_bottom">
                    <span class="make_grey">Date:</span> <p class="make_bold add_margin_left">{{invoiceDetails[0].creation_date | date}}</p>
                </div>
            </div>
        
            <div class="item_list add_padding">
                <div class="item_list_data add_margin_bottom" *ngFor="let item of invoiceDetails[0].invoiceDetails">
                    <span>{{item.serv_name}} x {{item.serv_qty}}</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{item.serv_cost.toFixed(2)}}</p>
                </div>
                <div class="item_list_data add_margin_bottom" *ngFor="let item of invoiceDetails[0].products">
                    <span>{{item.product_name}} x {{item.product_qty}}</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{item.product_price.toFixed(2)}}</p>
                </div>
                <div class="item_list_data add_margin_bottom" *ngFor="let item of invoiceDetails[0].custom_items">
                    <span>{{item.item_name}} x {{item.item_qty}}</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{item.item_price.toFixed(2)}}</p>
                </div>
            </div>
        
            <div class="item_list add_padding"  >
                <div class="item_list_data add_margin_bottom">
                    <span>Total</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].item_price.toFixed(2)}}</p>
                </div>
                <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].invoice_bill_type == 2 && invoiceDetails[0].total_tax && invoiceDetails[0].total_tax != '0.00' && invoiceDetails[0].total_tax != '0'">
                    <span>Tax</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{(+invoiceDetails[0].total_tax).toFixed(2)}}</p>
                </div>
                <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].discount != 0">
                    <span>Discount</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].discount.toFixed(2)}}</p>
                </div>
                 <div class="item_list_data add_margin_bottom" *ngIf="invoiceDetails[0].coupon_discount && invoiceDetails[0].coupon_discount != 0">
                    <span>Coupon discount</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].coupon_discount.toFixed(2)}}</p>
                </div>
               
                
               
                
            </div>
        
            <div class="item_list add_padding">
              
                <div class="item_list_data add_margin_bottom">
                    <span>Net payable</span > <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].total_price.toFixed(2)}}</p>
                </div>
            </div>
            <div class="item_list add_padding">
                <div class="item_list_data add_margin_bottom">
                    <span>Payment Amount</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].customer_payment ? invoiceDetails[0].customer_payment.toFixed(2) : '0.00'}}</p>
                </div>
                <div class="item_list_data add_margin_bottom">
                    <span>Payment Due</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{invoiceDetails[0].payment_due ? invoiceDetails[0].payment_due.toFixed(2) : '0.00'}}</p>
                </div>
            </div>
            <div class="item_list add_padding">
               
                <div class="item_list_data add_margin_bottom">
                    <span>Payment Mode</span> <p class="make_bold">{{invoiceDetails[0].payment_mode ? invoiceDetails[0].payment_mode : 'N/A'}}</p>
                </div>
                <div class="item_list_data add_margin_bottom">
                    <span>Reference Id</span> <p class="make_bold">{{invoiceDetails[0].pay_ref_id ? invoiceDetails[0].pay_ref_id : 'N/A'}}</p>
                </div>
            </div>
            <div class="item_list add_padding" *ngIf="invoiceDetails[0].tax_value_details">
               
                <div class="item_list_data add_margin_bottom" *ngFor="let item of invoiceDetails[0].tax_value_details">
                    <span>Total {{item.tax_name}}</span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{item.tax_value.toFixed(2)}}</p>
                </div>
                
            </div>
            <div class="item_list add_padding" style="border-bottom: none;" *ngIf="invoiceDetails[0].total_tax && invoiceDetails[0].total_tax != '0.00' && invoiceDetails[0].total_tax != '0' && invoiceDetails[0].total_tax != 0 ">
               
                <div class="item_list_data add_margin_bottom" >
                    <span>Total Tax Collected </span> <p class="make_bold">{{invoiceDetails[0].currency_symbol ? invoiceDetails[0].currency_symbol : '₹' }}{{(+invoiceDetails[0].total_tax).toFixed(2)}}</p>
                </div>
                
                
            </div>
            <!-- <div class="cust_info" style="padding: 16px 10px;">
                <div class="created_by">
                    <p class="make_grey" style="font-size: 12px;">Invoice powered by <span >Lookzup</span></p>
                </div>
                <div class="created_by">
                   <p class="make_grey" style="font-size: 12px;">Visit <span >lookzup.com</span> for more info</p>
                </div>
            </div> -->
        </div>
        </mat-dialog-content>

    <mat-dialog-content *ngIf="invoiceDetails.length == 0" style="height: 615px;">
        <div style="    text-align: center;
        padding-top: 300px;">
            <h2>Loading Invoice...</h2>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" *ngIf="invoiceDetails.length > 0">


        <!-- <button  mat-flat-button   color="accent" (click)="resetInvoice()" *ngIf="invoiceDetails[0].appointmentArr.length > 1 && invoiceDetails[0].paymentStatus != 1"
        >Reset</button>
        <button  mat-flat-button   color="accent" (click)="mergeInvoices()" *ngIf="invoiceDetails[0].appointmentArr.length == 1 && invoiceDetails[0].paymentStatus != 1"
        >Add Appointments</button>-->
        <button style="color: #fff;" mat-flat-button   color="accent" (click)="openRecordPayment()" *ngIf="invoiceDetails[0].payment_due != 0"
        >Record payment</button> 
                <button style="color: #fff;" *ngIf="invoiceDetails[0].isOnlinePaymentEnabled == 1 && invoiceDetails[0].payment_due != 0"
            (click)="sendInternationalPaymentLink()" mat-flat-button color="accent">Send payment link </button>
        <button style="color: #fff;" *ngIf="invoiceDetails[0].isOnlinePaymentEnabled != 1 || invoiceDetails[0].payment_due == 0"
        (click)="shareInWhatsapp()" mat-flat-button color="accent">Share in WhatsApp</button>
        <!-- <button style="color: #fff;"
        
        (click)="shareInWhatsapp()"
          mat-flat-button
          color="accent"
        >
        Share in WhatsApp  
        </button> -->
      </mat-dialog-actions>

    </div>